import React, { Component } from "react";


import { Container } from "reactstrap";

// datatable related plugins
// import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";


//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AddOfferForm from "../../../components/forms/OfferInfoForm/OfferInfoForm";
import { postOffer } from "../../../store/offers/actions";
import PreloaderData from './../../../components/PreloaderData/index';
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class OffersAddPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null
    };
  }

  componentDidMount() {
    // console.log(this.props);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if (prevProps.data !== this.props.data) {
    //   this._updateFilterName("created");
    // }
  }

  formSubmit = (data) => {
    this.props.postOffer({ data, history: this.props.history })
  }

  render() {

    const client_id = +this.props.location.state?.client_id
    const is_rent = +this.props.location.state?.is_rent

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Add offer| Mobihunter" />

          <Container fluid>
            <Breadcrumbs title="Offers list" breadcrumbItem="Add offer" link={`/clients/${client_id}#offers`} />
            { this.props.loader_offer ?
              (<PreloaderData />)
            :
              (<AddOfferForm
                onSubmit={this.formSubmit}
                client_id={client_id}
                is_rent={is_rent}
              />)
            }
            {/*<Row>*/}
            {/*  <Col className="col-12">*/}
            {/*    <Card>*/}
            {/*      <CardBody>*/}
            {/*        <CardTitle className="h4">Offer information </CardTitle>*/}
            {/*        /!*<button onClick={this.filter}>filter</button>*!/*/}
            {/*      </CardBody>*/}
            {/*    </Card>*/}
            {/*  </Col>*/}
            {/*</Row>*/}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

OffersAddPage.propTypes = {
  // data: PropTypes.any,
  // loading: PropTypes.bool,
  // getOffersAddPage: PropTypes.func,
  // deleteClient: PropTypes.func,
  history: PropTypes.any,
  postOffer: PropTypes.func,
  location: PropTypes.object,
  loader_offer: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  loader_offer: state.Offers.loader_offer,
});

export default connect(mapStateToProps, { postOffer })(OffersAddPage);
